<accordion [isAnimated]="true" [closeOthers]="true" class="card-box">
  <accordion-group [isOpen]="accordionOpen" (isOpenChange)="openAccordionGroup($event)">
    <div accordion-heading>
      <!-- SVG|Nome -->
      <div class="line-collapse">
        <!-- SVG e Nome -->
        <div class="svg-name">
          <!-- SVG -->
          <div *ngIf="typeDimension != typeSignDimensionEnum.Horizontal">
            <img [src]="typeDimension | enumSvg: 'TypeSignDimension'" height="32px" />
          </div>

          <div class="dimension-horizontal" *ngIf="typeDimension == typeSignDimensionEnum.Horizontal">
            <img class="svg-horizontal-dimension" [src]="'assets/signalings/horizontal/FTP-1.svg'" />
            <img class="svg-horizontal-dimension" style="left: 16px" [src]="'assets/signalings/horizontal/LFO-1.svg'" />
          </div>
          <!-- SVG -->

          <!-- Nome -->
          <div class="d-flex flex-column">
            <h3 class="text-muted">{{ typeDimension | enumText: 'TypeSignDimension' }}</h3>
          </div>
          <!-- Nome -->
        </div>
        <!-- SVG e Nome -->

        <!-- Botão Collapse -->
        <div class="d-flex align-items-center">
          <!-- Collapse -->
          <div class="collapse-button">
            <i class="fa-regular fa-lg" [ngClass]="accordionOpen ? 'fa-angle-up' : 'fa-angle-down'"></i>
          </div>
          <!-- Collapse -->
        </div>
        <!-- Botão Collapse -->
      </div>
      <!-- SVG|Nome -->
    </div>

    <div class="column-gap">
      <!-- ENVOLVENTES -->
      <div class="dimension-type-box">
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center">
            <ng-container *ngIf="typeDimension == typeSignDimensionEnum?.Horizontal">
              <div class="d-flex mr-2" *ngIf="typeDimension == typeSignDimensionEnum.Horizontal">
                <img class="mini-svg-horizontal-dimension" [src]="'assets/signalings/horizontal/MFE.svg'" />
                <img class="mini-svg-horizontal-dimension" [src]="'assets/signalings/horizontal/MFP.svg'" />
                <img class="mini-svg-horizontal-dimension" [src]="'assets/signalings/horizontal/MCI.svg'" />
              </div>
            </ng-container>
            <h4 class="text-muted">
              {{
                typeDimension == typeSignDimensionEnum?.Horizontal
                  ? 'SINALIZAÇÕES QUE NÃO REQUEREM COMPRIMENTO'
                  : 'ENVOLVENTES'
              }}
            </h4>
          </div>

          <ng-container *ngIf="typeDimension == typeSignDimensionEnum?.Horizontal">
            <i
              class="far fa-circle-info fa-lg cursor-pointer"
              [popover]="popoverWithoutHeight"
              [adaptivePosition]="false"
              placement="right bottom"
              container="body"
            ></i>
          </ng-container>
        </div>

        <!-- Lista Dimensões Horizontais que não requerem altura -->
        <ng-container *ngIf="typeDimension == typeSignDimensionEnum?.Horizontal">
          <ng-container
            *ngFor="
              let item of filterHorizontalList(
                dimensionHorizontalList,
                horizontalSignalingDimensionSettingTypeEnum.WithoutHeight
              );
              index as indexHorizontal
            "
          >
            <div class="d-flex w-100">
              <app-dimension-config-input
                class="w-100"
                [dimensionHorizontalItem]="item"
                [typeDimension]="typeDimension"
                [index]="indexHorizontal"
              ></app-dimension-config-input>
              <button
                class="btn btn-icon btn-icon-alt ml-2"
                style="min-width: 48px"
                (click)="removeDimensionSetting(item, 'horizontal')"
              >
                <i class="fas fa-xmark fa-lg text-danger"></i>
              </button>
            </div>
          </ng-container>
        </ng-container>
        <!-- Lista Dimensões Horizontais que não requerem altura -->

        <!-- Lista Dimensões Verticais Envolventes -->
        <ng-container *ngIf="typeDimension != typeSignDimensionEnum?.Horizontal">
          <ng-container
            *ngFor="
              let item of filterTrafficList(dimensionTrafficList, dimensionInformationEnum.Envolvente);
              index as indexVertical
            "
          >
            <div class="d-flex w-100">
              <app-dimension-config-input
                class="w-100"
                [dimensionItem]="item"
                [typeDimension]="typeDimension"
                [index]="indexVertical"
              ></app-dimension-config-input>
              <button
                class="btn btn-icon btn-icon-alt ml-2"
                style="min-width: 48px"
                (click)="removeDimensionSetting(item, 'traffic')"
              >
                <i class="fas fa-xmark fa-lg text-danger"></i>
              </button>
            </div>
          </ng-container>
        </ng-container>
        <!-- Lista Dimensões Verticais Envolventes -->

        <button class="btn btn-link" (click)="newDimension(typeDimension, dimensionInformationEnum.Envolvente)">
          <i class="fas fa-lg fa-plus-circle mr-2"></i>
          NOVA DIMENSÃO
        </button>
      </div>
      <!-- ENVOLVENTES -->

      <!-- EFETIVAS -->
      <div class="dimension-type-box" *ngIf="typeDimension != typeSignDimensionEnum.Rectangular">
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center">
            <ng-container *ngIf="typeDimension == typeSignDimensionEnum?.Horizontal">
              <div class="d-flex mr-2" *ngIf="typeDimension == typeSignDimensionEnum.Horizontal">
                <img class="mini-svg-horizontal-dimension" [src]="'assets/signalings/horizontal/SAS.svg'" />
                <img class="mini-svg-horizontal-dimension" [src]="'assets/signalings/horizontal/LDP.svg'" />
                <img class="mini-svg-horizontal-dimension" [src]="'assets/signalings/horizontal/MAC.svg'" />
              </div>
            </ng-container>

            <h4 class="text-muted">
              {{ typeDimension == typeSignDimensionEnum?.Horizontal ? 'SINALIZAÇÕES QUE REQUEREM COMPRIMENTO' : 'EFETIVAS' }}
            </h4>
          </div>

          <ng-container *ngIf="typeDimension == typeSignDimensionEnum?.Horizontal">
            <i
              class="far fa-circle-info fa-lg cursor-pointer"
              [popover]="popoverWithHeight"
              [adaptivePosition]="false"
              placement="right bottom"
              container="body"
            ></i>
          </ng-container>
        </div>

        <!-- Lista Dimensões Horizontais que requerem altura -->
        <ng-container *ngIf="typeDimension == typeSignDimensionEnum?.Horizontal">
          <ng-container
            *ngFor="
              let item of filterHorizontalList(
                dimensionHorizontalList,
                horizontalSignalingDimensionSettingTypeEnum.WithHeight
              );
              index as indexHorizontal
            "
          >
            <div class="d-flex w-100">
              <app-dimension-config-input
                class="w-100"
                [dimensionHorizontalItem]="item"
                [typeDimension]="typeDimension"
                [index]="indexHorizontal"
              ></app-dimension-config-input>
              <button
                class="btn btn-icon btn-icon-alt ml-2"
                style="min-width: 48px"
                (click)="removeDimensionSetting(item, 'horizontal')"
              >
                <i class="fas fa-xmark fa-lg text-danger"></i>
              </button>
            </div>
          </ng-container>
        </ng-container>
        <!-- Lista Dimensões Horizontais que requerem altura -->

        <!-- Lista Dimensões Verticais Efetivas -->
        <ng-container *ngIf="typeDimension != typeSignDimensionEnum?.Horizontal">
          <ng-container
            *ngFor="
              let item of filterTrafficList(dimensionTrafficList, dimensionInformationEnum.Efetiva);
              index as indexVertical
            "
          >
            <div class="d-flex w-100">
              <app-dimension-config-input
                class="w-100"
                [dimensionItem]="item"
                [typeDimension]="typeDimension"
                [index]="indexVertical"
              ></app-dimension-config-input>
              <button
                class="btn btn-icon btn-icon-alt ml-2"
                style="min-width: 48px"
                (click)="removeDimensionSetting(item, 'traffic')"
              >
                <i class="fas fa-xmark fa-lg text-danger"></i>
              </button>
            </div>
          </ng-container>
        </ng-container>
        <!-- Lista Dimensões Verticais Efetivas -->

        <button class="btn btn-link" (click)="newDimension(typeDimension, dimensionInformationEnum.Efetiva)">
          <i class="fas fa-lg fa-plus-circle mr-2"></i>
          NOVA DIMENSÃO
        </button>
      </div>
      <!-- EFETIVAS -->
    </div>
  </accordion-group>
</accordion>

<!-- Template Popover Sinalização Conjugada  -->
<ng-template #popoverWithoutHeight>
  <div class="popover-scroll">
    <h3>Sem Dimensão de Comprimento</h3>
    <div *ngFor="let horizontal of horizontalWithoutHeight; let IndexSign = index" class="horizontal-box">
      <img [src]="horizontal | enumSvg: 'Signaling'" style="width: 24px; object-fit: contain; height: 24px" />
      <h4 class="regular">{{ horizontal | enumText: 'Signaling' }}</h4>
    </div>
  </div>
</ng-template>
<!-- Template Popover Sinalização Conjugada  -->

<!-- Template Popover Sinalização Conjugada  -->
<ng-template #popoverWithHeight>
  <div class="popover-scroll">
    <h3>Com Dimensão de Comprimento</h3>
    <div *ngFor="let horizontal of horizontalWithHeight; let IndexSign = index" class="horizontal-box">
      <img [src]="horizontal | enumSvg: 'Signaling'" style="width: 24px; object-fit: contain; height: 24px" />
      <h4 class="regular">{{ horizontal | enumText: 'Signaling' }}</h4>
    </div>
  </div>
</ng-template>
<!-- Template Popover Sinalização Conjugada  -->
